<template>
  <div>
    <div class="custom-pagination-container">
      <div
        class="custom-pagination-previos"
        :class="activePage > 1 ? 'custom-pagination-previos-active' : ''"
        @click="previosPage()"
      >
        <i class="icon fas fa-angle-left font-weight-light fa-2x "></i>
      </div>
      <div class="custom-pagination-pages">
        <span class="page-active pr-1">{{ activePage }}</span> /
        <span class="pl-1">{{ countPages }}</span>
      </div>
      <div
        class="custom-pagination-next"
        :class="activePage < countPages ? 'custom-pagination-next-active' : ''"
        @click="nextPage()"
      >
        <i class="icon fas fa-angle-right font-weight-light fa-2x"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activePage: Number,
    countPages: Number
  },
  data() {
    return {
      page: 1
    }
  },
  mounted() {
    this.page = this.activePage
  },
  methods: {
    nextPage() {
      if (this.activePage < this.countPages) {
        let value = this.activePage + 1
        this.$emit('update:activePage', value)
      }
    },
    previosPage() {
      if (this.activePage > 1) {
        let value = this.activePage - 1
        this.$emit('update:activePage', value)
      }
    }
  }
}
</script>

<style lang="scss">
.custom-pagination-container {
  display: flex;
}

.custom-pagination-previos {
  flex: 2;
  text-align: center;
  color: $gray-500;
}

.custom-pagination-previos-active {
  cursor: pointer;
  color: $gray-base;
}

.custom-pagination-pages {
  flex: 8;
  text-align: center;
  align-self: center;
  color: $gray-500;
  font-weight: 900;
}

.custom-pagination-next {
  flex: 2;
  text-align: center;
  color: $gray-500;
}

.custom-pagination-next-active {
  cursor: pointer;
  color: $gray-base;
}

.page-active {
  color: $gray-base;
  font-weight: 900;
}
</style>
